export default "__VITE_ASSET__CEN3HqLF__"